import OQFilesApi from "@/api/OQFilesApi";

const CHUNK_SIZE = 1024 * 1024 * 2;
const MAX_FILE_SIZE = 1024 * 1024 * 1024;
// let TOTAL_FILES = 0;
const FileUtils = {
  MAX_FILE_SIZE,
  CHUNK_SIZE,
  human_size: function (value) {
    if (!value) return "";
    const sizes = ["б", "кб", "мб", "гб", "тб"];
    let i = 0;
    while (value > 1024) {
      value = value / 1024;
      i += 1;
    }
    return value.toFixed(1) + " " + sizes[i];
  },
  readNewFile: (options, callback = () => {}) => {
    return new Promise((resolve, reject) => {
      const results = [];
      const input = document.createElement("input");
      input.style.display = "none";
      input.multiple = true;
      input.type = "file";
      input.accept =
        options.mimes && options.mimes.length > 0
          ? `${(options.mimes || []).join(",")}`
          : undefined;
      const onchange_event = async (e) => {
        document.body.removeChild(input);
        const total_files = e.target.files.length;
        for (const file of e.target.files) {
          if (
            options.mimes &&
            options.mimes.length > 0 &&
            !options.mimes.filter((m) => file.type.match(m.replace("*", ".*")))
              .length > 0
          ) {
            reject(
              `
            Файл "${file.name}" имеет не допустимое расширение.
            Мы принимаем файлы с расширениями: 
            "${(options.formats || []).join('", "')}".
            `
            );
            continue;
          }
          if (file.size > MAX_FILE_SIZE) {
            reject(`Не более ${FileUtils.human_size(MAX_FILE_SIZE)}`);
            continue;
          }

          const iterations = Math.ceil(file.size / CHUNK_SIZE) + 1;
          let iteration = 0;
          const file_id = await OQFilesApi.startFileUploading({
            file_size: file.size,
            file_name: file.name,
            default_options: options.default_options,
          });

          if (!file_id) return reject("Сервис временно не доступен");

          callback({
            start: true,
            id: file_id,
            file_size: file.size,
            file_name: file.name,
            uploaded_file_size: 0,
          });
          const chunk_reader = async () => {
            if (iteration >= iterations) {
              const file_info = await OQFilesApi.getFileInfo(file_id);
              results.push({
                id: file_id,
                done: true,
                file_size: file.size,
                file_name: file.name,
                uploaded_file_size: file.size,
                file_url: process.env.VUE_APP_OQ_FILE_API + "/get/" + file_id,
                file_info,
                page_count: file_info?.page_count || 1,
                color_pages: "",
                exclude_pages: "",
              });
              if (results.length >= total_files) resolve(results);
              return;
            }

            const reader = new FileReader();
            reader.onload = async (readerEvent) => {
              const content = readerEvent.target.result;
              const server_size = await OQFilesApi.uploadFileChunk(
                file_id,
                content,
                iteration * CHUNK_SIZE,
                CHUNK_SIZE
              );

              if (server_size === undefined)
                return reject("Сервис временно не доступен");

              const size =
                iteration * CHUNK_SIZE + CHUNK_SIZE > file.size
                  ? file.size
                  : iteration * CHUNK_SIZE + CHUNK_SIZE;

              callback({
                id: file_id,
                progress: true,
                file_size: file.size,
                file_name: file.name,
                uploaded_file_size: size,
                server_size,
              });
              iteration += 1;
              await chunk_reader();
            };
            reader.readAsBinaryString(
              file.slice(
                iteration * CHUNK_SIZE,
                iteration * CHUNK_SIZE + CHUNK_SIZE
              )
            );
          };
          await chunk_reader();
        }
      };

      input.addEventListener("change", onchange_event);

      document.body.appendChild(input);

      if (options.files) {
        input.files = options.files;
        input.dispatchEvent(new Event("change"));
      } else input.click();
    });
  },
  setMetaInfo: (file_id, options) => {
    return OQFilesApi.setFileInfo(file_id, options);
  },
  getResizedFile: (file_id, options) => {
    return OQFilesApi.getResizedFile(file_id, options);
  },
  getCroppedFile: (file_id) => {
    return OQFilesApi.getCroppedFile(file_id);
  },
};

export default FileUtils;
